import {
  type GetWorkplaceAgreementsResponse,
  GetWorkplaceAgreementsResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment/config";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

interface UseGetWorkplaceAgreementsQueryParams extends Record<string, unknown> {
  include?: Array<"document">;
}

export function createUseGetWorkplaceAgreementsQueryKey(
  workplaceId: string,
  queryParams?: UseGetWorkplaceAgreementsQueryParams
) {
  return [
    `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/agreements`,
    queryParams,
  ];
}

export function useGetWorkplaceAgreements(
  workplaceId: string | undefined,
  queryParams?: UseGetWorkplaceAgreementsQueryParams,
  options?: UseGetQueryOptions<GetWorkplaceAgreementsResponse>
) {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/agreements`,
    queryParams,
    responseSchema: GetWorkplaceAgreementsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKPLACE_AGREEMENTS_FAILURE,
    },
    enabled: isDefined(workplaceId),
    ...options,
  });
}
